import api from '@pray/shared/utils/api';

export async function deleteOrganizationFund(organizationId: string, fundId: string) {
  const url = `/web/studio/organizations/${organizationId}/funds/${fundId}`;

  await api.executeDeleteRequest(url);

  return { success: true };
}
